import type { ReactNode } from "react";

const ROW_H = "h-[1.45em]";

export type SlidingLabelTextProps = {
  line1ClassName: string;
  line2ClassName: string;
  /** First line content */
  children: ReactNode;
  /** Second line (defaults to same as `children`) */
  line2?: ReactNode;
};

/**
 * Vertical sliding text animation for labels and buttons.
 * Triggered by the 'group-hover' state on the parent element.
 */
export default function SlidingLabelText({
  line1ClassName,
  line2ClassName,
  children,
  line2,
}: SlidingLabelTextProps) {
  const second = line2 ?? children;

  return (
    <span className={`inline-block overflow-hidden align-middle ${ROW_H}`}>
      <span
        className="flex flex-col transition-transform duration-300 will-change-transform group-hover:-translate-y-1/2 motion-reduce:transition-none motion-reduce:group-hover:translate-y-0"
        style={{ transitionTimingFunction: "cubic-bezier(0.65, 0.05, 0.32, 1)" }}
      >
        <span
          className={`flex shrink-0 items-center justify-start whitespace-nowrap ${ROW_H} ${line1ClassName}`}
        >
          {children}
        </span>
        <span
          className={`flex shrink-0 items-center justify-start whitespace-nowrap ${ROW_H} ${line2ClassName}`}
        >
          {second}
        </span>
      </span>
    </span>
  );
}
